/* AFZ bundle code auto-apply, v6 (2026-10-09).
 * Native Shopify discounts remain authoritative.
 * New campaigns register from their own product metafield through the existing
 * SKU resolver. No new product IDs, prices, or discount amounts live here.
 */
(function () {
  'use strict';
  var LEGACY = {
    '15457900626052': { discounts: [
      { code: 'AFZ-BOOMBA-2', minimum_quantity: 2 },
      { code: 'AFZ-BOOMBA-3', minimum_quantity: 3 } ] },
    '15457900527748': { discounts: [
      { code: 'AFZ-PEPPER-2', minimum_quantity: 2 },
      { code: 'AFZ-PEPPER-3', minimum_quantity: 3 } ] },
    '15457900953732': { discounts: [
      { code: 'AFZ-ANAONO-3', minimum_quantity: 3 } ] },
    '15457900462212': { discounts: [
      { code: 'AFZ-THIGH-2', minimum_quantity: 2 },
      { code: 'AFZ-THIGH-3', minimum_quantity: 3 } ] }
  };
  var registry = Object.assign({}, LEGACY);
  var owned = {};
  var configCache = {};
  var suppressed = {};
  var previous = null;
  var pending = null;
  var explicitResets = {};
  var storageKey = 'afz.bundle.code-state.v6';
  var root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  var refreshMs = 300000;
  var standardEvents = import('@shopify/events');

  function ownRules(pid, rules) {
    rules.forEach(function (rule) {
      if (rule.code) owned[rule.code.toLowerCase()] = { productId: pid, rule: rule };
    });
  }
  Object.keys(LEGACY).forEach(function (pid) { ownRules(pid, LEGACY[pid].discounts); });

  function register(pid, config) {
    if (!config || config.version !== 1 || config.source !== 'shopify_discount_nodes' ||
        String(config.product_id) !== pid || config.enabled !== true) return false;
    if (!LEGACY[pid] && config.auto_apply !== true) return false;
    var rules = (config.discounts || []).filter(function (rule) {
      return rule.method === 'code' && String(rule.product_id) === pid &&
        typeof rule.code === 'string' && rule.code.length > 0 &&
        Number.isInteger(rule.minimum_quantity) && rule.minimum_quantity > 1;
    });
    if (!rules.length) return false;
    registry[pid] = { discounts: rules };
    ownRules(pid, rules);
    return true;
  }

  try {
    var saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
    if (saved) {
      suppressed = saved.suppressed || {};
      previous = saved.previous || null;
      Object.keys(saved.configs || {}).forEach(function (pid) {
        var entry = saved.configs[pid];
        // Keep code ownership so removal still clears codes on a later page.
        if (entry.config && (LEGACY[pid] || entry.config.auto_apply === true)) ownRules(pid, entry.config.discounts || []);
        if (Date.now() - entry.time < refreshMs) {
          configCache[pid] = entry;
          register(pid, entry.config);
        }
      });
    }
  } catch (error) { /* Storage is optional. */ }

  function persist() {
    try {
      sessionStorage.setItem(storageKey, JSON.stringify({
        configs: configCache, suppressed: suppressed, previous: previous
      }));
    } catch (error) { /* Storage is optional. */ }
  }

  function productSignatures(cart) {
    var rows = {};
    (cart.items || []).forEach(function (item) {
      var pid = String(item.product_id);
      var key = String(item.variant_id || item.id) + ':' + JSON.stringify(item.properties || {});
      var productRows = rows[pid] || (rows[pid] = {});
      // Shopify splits a free unit from paid units of the same SKU. Removing
      // its discount merges them again; that is still the same selection.
      productRows[key] = (productRows[key] || 0) + item.quantity;
    });
    var result = {};
    Object.keys(rows).forEach(function (pid) {
      result[pid] = Object.keys(rows[pid]).sort().map(function (key) {
        return key + ':' + rows[pid][key];
      }).join('|');
    });
    return result;
  }

  function appliedCodes(cart) {
    return (cart.discount_codes || []).map(function (entry) {
      return typeof entry === 'string' ? entry : entry.code;
    }).filter(Boolean);
  }

  async function discover(cart) {
    var handles = {};
    (cart.items || []).forEach(function (item) {
      if (item.handle) handles[String(item.product_id)] = item.handle;
    });
    // Small section responses contain only the product's resolver/config data.
    // An unrelated product is cached as absent and has no code changes.
    await Promise.all(Object.keys(handles).map(async function (pid) {
      var entry = configCache[pid];
      if (entry && Date.now() - entry.time < refreshMs) return;
      try {
        var url = root + 'products/' + encodeURIComponent(handles[pid]) + '?section_id=afz-bundle-variant';
        var response = await fetch(url, { headers: { Accept: 'text/html' }, cache: 'no-store' });
        if (!response.ok) return;
        var html = new DOMParser().parseFromString(await response.text(), 'text/html');
        var config = null;
        html.querySelectorAll('[data-afz-bundle-config]').forEach(function (node) {
          try {
            var candidate = JSON.parse(node.textContent);
            if (String(candidate.product_id) === pid) config = candidate;
          } catch (error) { /* Ignore malformed or unrelated data. */ }
        });
        configCache[pid] = { time: Date.now(), config: config };
        if (!register(pid, config) && !LEGACY[pid]) delete registry[pid];
      } catch (error) { /* Never interrupt shopping when discovery fails. */ }
    }));
    persist();
  }

  function bestCodeFor(pid, quantity) {
    var best = null;
    var now = Date.now();
    (registry[pid].discounts || []).forEach(function (rule) {
      if (rule.status && !['ACTIVE', 'SCHEDULED'].includes(rule.status)) return;
      if (rule.starts_at && Date.parse(rule.starts_at) > now) return;
      if (rule.ends_at && Date.parse(rule.ends_at) <= now) return;
      if (quantity >= rule.minimum_quantity &&
          (!best || rule.minimum_quantity > best.minimum_quantity)) best = rule;
    });
    return best;
  }

  function readCart() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart read failed');
        return response.json();
      });
  }

  function actualSavings(cart, code, rule) {
    var aliases = [code, rule.title].filter(Boolean).map(function (title) { return title.toLowerCase(); });
    var amount = 0;
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(function (allocation) {
        var application = allocation.discount_application || {};
        if (aliases.indexOf(String(application.title || '').toLowerCase()) >= 0) amount += Number(allocation.amount) || 0;
      });
    });
    (cart.cart_level_discount_applications || []).forEach(function (application) {
      if (aliases.indexOf(String(application.title || '').toLowerCase()) >= 0) amount += Number(application.total_allocated_amount) || 0;
    });
    return amount;
  }

  function showCartTruth(cart) {
    document.querySelectorAll('.afz-auto-discount-note').forEach(function (node) { node.remove(); });
    var drawer = document.getElementById('cart-drawer') ||
      document.getElementById('afz-cart-page') || document.querySelector('cart-drawer-component');
    if (!drawer) return;
    // Retain the theme's visible label/currency format; use Shopify's real total.
    if (typeof cart.total_price !== 'number') return;
    var walker = document.createTreeWalker(drawer, NodeFilter.SHOW_TEXT);
    var label, node;
    while ((node = walker.nextNode())) {
      if (/Estimated total/i.test(node.textContent.trim())) { label = node; break; }
    }
    var container = label && label.parentElement;
    for (var depth = 0; depth < 4 && container; depth++, container = container.parentElement) {
      var elements = container.querySelectorAll('*');
      for (var index = 0; index < elements.length; index++) {
        var el = elements[index];
        var match = el.textContent.trim().match(/^\$([\d,]+\.\d{2})(\s*USD)?$/);
        if (match && !el.querySelector('*')) {
          el.textContent = '$' + (cart.total_price / 100).toFixed(2) + (match[2] || '');
          return;
        }
      }
    }
  }

  function observeRemoval(cart, have, signatures) {
    if (previous) {
      previous.codes.forEach(function (code) {
        var owner = owned[code.toLowerCase()];
        if (!owner || explicitResets[owner.productId]) return;
        if (!have.some(function (value) { return value.toLowerCase() === code.toLowerCase(); }) &&
            signatures[owner.productId] === previous.signatures[owner.productId]) {
          suppressed[owner.productId] = signatures[owner.productId];
        }
      });
    }
    Object.keys(suppressed).forEach(function (pid) {
      if (explicitResets[pid] || suppressed[pid] !== signatures[pid]) delete suppressed[pid];
    });
    explicitResets = {};
  }

  function cartSectionIds() {
    var sections = [];
    document.querySelectorAll('cart-items-component, cart-discount[data-section-id]').forEach(function (node) {
      if (node.dataset.sectionId && sections.indexOf(node.dataset.sectionId) < 0) sections.push(node.dataset.sectionId);
    });
    return sections.slice(0, 5);
  }

  async function renderCartSections(cart) {
    var sections = cartSectionIds();
    if (!sections.length) return;
    // The add response can predate a concurrent discount sync. Read the
    // rendered rows after that sync, so free items and totals agree.
    var rendered = {};
    await Promise.all(sections.map(async function (id) {
      var url = new URL(window.location.href);
      url.searchParams.set('section_id', id);
      url.searchParams.set('_afz_cart_refresh', String(Date.now()));
      var response = await fetch(url.toString(), { cache: 'no-store' });
      if (!response.ok) return;
      var html = await response.text();
      var doc = new DOMParser().parseFromString(html, 'text/html');
      if (doc.getElementById('shopify-section-' + id)) rendered[id] = html;
    }));
    if (Object.keys(rendered).length) cart.sections = rendered;
  }

  async function runSync(options) {
    var cart = await readCart();
    await discover(cart);
    var have = appliedCodes(cart);
    var signatures = productSignatures(cart);
    observeRemoval(cart, have, signatures);
    var quantities = {};
    (cart.items || []).forEach(function (item) {
      var pid = String(item.product_id);
      if (registry[pid]) quantities[pid] = (quantities[pid] || 0) + item.quantity;
    });
    var next = have.filter(function (code) { return !owned[code.toLowerCase()]; });
    Object.keys(quantities).forEach(function (pid) {
      if (suppressed[pid] === signatures[pid]) return;
      var best = bestCodeFor(pid, quantities[pid]);
      if (best && !next.some(function (code) { return code.toLowerCase() === best.code.toLowerCase(); })) next.push(best.code);
    });
    var same = next.length === have.length && next.every(function (code) {
      return have.some(function (value) { return value.toLowerCase() === code.toLowerCase(); });
    });
    if (!same) {
      var sections = cartSectionIds();
      var response = await fetch(root + 'cart/update.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ discount: next.join(','), sections: sections.slice(0, 5).join(','), sections_url: window.location.pathname })
      });
      if (!response.ok) throw new Error('Discount update failed');
      var updated = await response.json();
      if (updated.status) throw new Error('Discount update failed');
      cart = updated;
      // Store our own update before dispatch, so it cannot look like manual removal.
      previous = { codes: appliedCodes(cart), signatures: productSignatures(cart) };
      persist();
    }
    if (!same || (options && options.resetProductId)) {
      await renderCartSections(cart);
      var events = await standardEvents;
      document.dispatchEvent(new events.CartDiscountUpdateEvent({
        context: 'cart',
        promise: Promise.resolve({
          cart: events.CartDiscountUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { didError: false, sections: cart.sections, source: 'afz-bundle-discounts' }
        })
      }));
    }
    previous = { codes: appliedCodes(cart), signatures: productSignatures(cart) };
    persist();
    showCartTruth(cart);
    return cart;
  }

  function sync(options) {
    if (pending) {
      // A poll started before an add may hold an earlier cart snapshot.
      return options && options.resetProductId ? pending.then(function () { return sync(options); }) : pending;
    }
    if (options && options.resetProductId) explicitResets[String(options.resetProductId)] = true;
    pending = runSync(options).catch(function () { return null; }).finally(function () { pending = null; });
    return pending;
  }
  window.AFZBundleDiscounts = { sync: sync };
  setInterval(function () { if (!document.hidden) sync(); }, 1000);
  ['cart-lines:update', 'cart:change', 'cart-update'].forEach(function (name) {
    document.addEventListener(name, function () { setTimeout(sync, 400); }, true);
  });
  standardEvents.then(function (events) {
    [events.StandardEvents.cartLinesUpdate, events.StandardEvents.cartDiscountUpdate].forEach(function (name) {
      document.addEventListener(name, function (event) {
        if (event.promise) event.promise.then(function () { setTimeout(sync, 400); }).catch(function () {});
        else setTimeout(sync, 400);
      }, true);
    });
  });
  sync();
})();

